var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGqIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "100%",
    viewBox: "0 0 1000 618",
    enableBackground: "new 0 0 1000 618",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#B57EDC",
    opacity: 1,
    stroke: "none",
    d: " M1.000000,207.000000  C1.000000,138.354141 1.000000,69.708282 1.000000,1.031212  C334.211517,1.031212 667.423035,1.031212 1001.000000,1.031212  C1001.000000,69.356979 1001.000000,137.714600 1000.536133,206.535294  C667.048157,206.998901 334.024078,206.999451 1.000000,207.000000  z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    opacity: 1,
    stroke: "none",
    d: " M1.000000,207.463882  C334.024078,206.999451 667.048157,206.998901 1000.536133,206.999176  C1001.000000,275.357422 1001.000000,343.714813 1000.746948,412.548706  C1000.333435,413.078156 1000.173035,413.131104 999.556946,413.110260  C996.935425,413.024384 994.769653,413.001587 992.603821,413.001587  C664.540527,413.000031 336.477234,413.000397 8.413938,412.993195  C6.251753,412.993134 4.089571,412.888977 1.797783,412.667542  C1.486269,412.280029 1.263544,412.112823 1.000000,412.000000  C1.000000,343.975922 1.000000,275.951843 1.000000,207.463882  z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#4A8123",
    opacity: 1,
    stroke: "none",
    d: " M1.927388,412.833435  C4.089571,412.888977 6.251753,412.993134 8.413938,412.993195  C336.477234,413.000397 664.540527,413.000031 992.603821,413.001587  C994.769653,413.001587 996.935425,413.024384 999.702515,413.267944  C1000.518555,413.690308 1000.750610,413.857178 1001.000000,414.000000  C1001.000000,482.313019 1001.000000,550.626038 1001.000000,618.969482  C667.786072,618.969482 334.572174,618.969482 1.000000,618.969482  C1.000000,550.973572 1.000000,482.946472 1.189917,414.342896  C1.630007,413.602417 1.854450,413.408600 2.080463,413.076080  C2.107764,412.967194 1.927389,412.833435 1.927388,412.833435  z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#F6F9F4",
    opacity: 1,
    stroke: "none",
    d: " M1.000000,412.250000  C1.263544,412.112823 1.486269,412.280029 1.797783,412.667542  C1.927389,412.833435 2.107764,412.967194 1.822899,412.997223  C1.358689,413.018188 1.179344,413.009094 1.000000,413.000000  C1.000000,413.000000 1.000000,412.500000 1.000000,412.250000  z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#53872E",
    opacity: 1,
    stroke: "none",
    d: " M1.000000,413.250000  C1.179344,413.009094 1.358689,413.018188 1.795598,413.106110  C1.854450,413.408600 1.630007,413.602417 1.189917,413.883209  C1.000000,414.000000 1.000000,413.500000 1.000000,413.250000  z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#53872E",
    opacity: 1,
    stroke: "none",
    d: " M1001.000000,413.750000  C1000.750610,413.857178 1000.518555,413.690308 1000.158203,413.341675  C1000.173035,413.131104 1000.333435,413.078156 1000.746948,413.012573  C1001.000000,413.000000 1001.000000,413.500000 1001.000000,413.750000  z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGqIcon);
export default __webpack_public_path__ + "static/media/gq-icon.27b4a2dc0d1040147424501f0f4bf9f8.svg";
export { ForwardRef as ReactComponent };